import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

/**
 * Axios instance pre-configured for the Rentagade backend.
 *
 * The base URL is read from REACT_APP_API_BASE_URL (defined in .env).
 * Add an auth token by setting it via setAuthToken() after login.
 */
const baseURL: string =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const api: AxiosInstance = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token from localStorage on every request, if present.
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('auth_token')
      : null;
  if (token && config.headers) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

// Centralised error handling - bubble up errors so callers can react.
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    // You can add global handling here (e.g. redirect on 401).
    return Promise.reject(error);
  }
);

export const setAuthToken = (token: string | null) => {
  if (typeof window === 'undefined') return;
  if (token) {
    window.localStorage.setItem('auth_token', token);
  } else {
    window.localStorage.removeItem('auth_token');
  }
};

export default api;
